import {request} from '@/helpers/apiClient'
import {BULK_MODIFIERS_CONFIG} from '@/utils/constants/apiConfig/bulkModifierConfig'

export const getBulkModifiers = (queryParams, searchArr) =>
  request(BULK_MODIFIERS_CONFIG.BULK_MODIFIERS(queryParams), {data: searchArr})

export const handlePointModifers = async req_param => {
  return await request(BULK_MODIFIERS_CONFIG.REVIEW_BULK_MODIFIERS, req_param)
}

export const getBulkModifiersDetails = (id, page, pageSize, type) =>
  request(BULK_MODIFIERS_CONFIG.BULK_MODIFIER_DETAIL(id, page, pageSize, type), {})

export const getBulkModifierCsvFile = (queryParams,body) => request(BULK_MODIFIERS_CONFIG.BULK_MODIFIERS_CSV_DOWNLOAD(queryParams), {data: body})

export const postBulkPointModifiersDraft = async req_param => {
  return request(BULK_MODIFIERS_CONFIG.BULK_MODIFIERS_DRAFT, req_param)
}

export const putBulkPointModifiersDraft = async req_param => {
  return request(BULK_MODIFIERS_CONFIG.BULK_MODIFIERS_DRAFT_UPDATE, req_param)
}

export const validateBulkPointModifierName = queryParams =>
  request(BULK_MODIFIERS_CONFIG.VALIDATE_BULK_MODIFIER_NAME, '', queryParams)
